		/**
		 * @ngdoc service
		 * @name WebCoreModule.service:WcDataFileService
		 * @requires $q
		 * @requires $window
		 * @description
		 * The WcDataFileService manages the file related operations while uploading the file.
		 */


angular.module('WebCoreModule')
	.service('WcDataFileService', ['$q', '$window', function($q, $window) {
		this.getFileType = function(fileDef) {
			//noinspection UnnecessaryLocalVariableJS
            var fileType = fileDef.type.replace(/[a-z]+\//, '');
			return fileType;
		};

		/**
		 * @ngdoc method
		 * @name WcImageFileService.prepareForFileUpload
		 * @methodOf WebCoreModule.service:WcDataFileService
		 * @param {String} base64DataUri This string value holds the data uri
		 * @returns {Object} The object value holds the file
		 * @description
		 * The WcImageFileService provides a prepareForFileUpload function to create a file  object from the provided url.
		 */

		this.prepareForFileUpload = function(base64DataUri) {
			//noinspection UnnecessaryLocalVariableJS
            var fileObj = {
				MIMEType: base64DataUri.match(/^[^,]*,/, '')[0],
				base64String: base64DataUri.replace(/^[^,]*,/, '')
			};

			return fileObj;
		};

		/**
		 * @ngdoc method
		 * @name WcImageFileService.readFile
		 * @methodOf WebCoreModule.service:WcDataFileService
		 * @param {Object} fileDef This object value holds definition of the file.
		 * @returns {Promise} Return dataURI as a promise
		 * @description
		 * The WcImageFileService provides a readFile function to read the uploaded file.
		 */

		this.readFile = function(fileDef) {
			// Return dataURI as a promise
			//https://gist.github.com/jollytoad/4201905
			var deferred = $q.defer();
			var reader = new $window.FileReader();

			reader.onload = function(loadEvent){
				var dataUri = loadEvent.target.result;
				deferred.resolve(dataUri);
			};

			reader.onerror = function(){
				deferred.reject(fileDef);
			};

			reader.readAsDataURL(fileDef);

			return deferred.promise;
		};
	}]
);